import axios from "axios";

export function validateEmail(e) {
  return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(e);
}

export default function setHeader(headers) {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userId")}`,
      ...headers,
    },
  };
}

export function validatePassword(password) {
  // Regular expression pattern to match the password criteria
  var pattern = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

  // Test the password against the pattern
  return pattern.test(password);
}

export function clearStorage() {
  localStorage.removeItem("userId");
  window.dispatchEvent(new Event("auth-change"));
}

export function authenticate() {
  return async (dispatch) => {
    try {
      let response = await axios.get(`/api/users/checkLog`, setHeader());
      if (response.data.error) {
        //return to global state
      }
    } catch (e) {
      console.log("authenticate", e);
    }
  };
}

export async function Axios(type, path, body, headers) {
  let response;

  try {
    // Make the API request based on the HTTP method type (POST or GET)
    if (type === "POST") {
      response = await axios.post(path, body, setHeader(headers));
    } else if (type === "GET") {
      response = await axios.get(path, setHeader(headers));
    }

    console.log("response", response);

    // Check if the response contains a success status
    if (response.data.success) {
      return response; // Return successful response if no issues
    } else {
      // Handle the case where the API returns a success: false
      clearStorage();
      // Optionally, re-authenticate if necessary
      // authenticate();
      return {
        data: {
          success: false,
          error: response.data.error || "Invalid Login, Please try again.",
        },
      };
    }
  } catch (e) {
    // Error handling if the request failed
    console.error("Axios Error", e);

    // Check if the error contains a response from the server
    if (e.response) {
      // Server responded with an error status code (e.g., 400, 500)
      return {
        data: {
          success: false,
          error: e.response.data.error || "An unexpected error occurred.",
        },
      };
    } else {
      // Network-related error (no response)
      return {
        data: {
          success: false,
          error:
            "Internal unexpected error, please contact support. " + e.message,
        },
      };
    }
  }
}
